import { FC, useContext } from 'react';
import { CompanyDashboardContext } from '../../../../Utils';
import { Schedules } from '../../../../../../Components/Forms/Schedule';

export const CompanyDashboardSurveysTab: FC = () => {
    const { company, searchText } = useContext(CompanyDashboardContext);

    return <Schedules company={company} searchText={searchText} />;
};